<template>
  <v-card flat>
    <v-card-title>
      <h3 class="font-weight-light text-xs-center grow yellow lighten-4">
        <span>{{ selectedSpan === 0 ? '週' : '月' }}</span>
        計
      </h3>
    </v-card-title>
    <v-card-text class="summary-table">
      <div class="summary-box summary-title">
        配送回数
      </div>
      <div class="summary-box summary-text">
        {{ setCommas(getGraphData[2].count) }}回
      </div>
      <div class="summary-box summary-title">
        配送量
      </div>
      <div class="summary-box summary-text">
        {{ setCommas(getGraphData[2].amount) }}ℓ
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { setCommas } from '@/utils/helpers.js'
export default {
  computed: {
    ...mapState('dashboard', ['selectedSpan']),
    ...mapGetters('dashboard', ['getGraphData'])
  },
  methods: {
    setCommas (v) {
      return setCommas(v)
    }
  }
}
</script>
